module.exports = __webpack_public_path__ + "img/css3.81b900ba.png";